import { defineMessages, IntlProvider } from 'react-intl';

import Agent from './data-sources/Agent';
import Chart from '../models/Chart';
import ChartOption from '../models/ChartOption';

const messages = defineMessages({
  AGGREGATED: {
    id: 'AGGREGATED',
    defaultMessage: 'Aggregate',
  },
  PER_AGENT: {
    id: 'PER_AGENT',
    defaultMessage: 'Per Agent',
  },
  PER_QUEUE: {
    id: 'PER_QUEUE',
    defaultMessage: 'Per Queue',
  },
});

/**
 * Returns gauge chart manifest
 * @param locale
 * @returns {Chart}
 */
// eslint-disable-next-line import/prefer-default-export
export const initResponsiveGridTable = (locale = 'en_us') => {
  const { intl } = new IntlProvider({
    locale,
    messages,
  }, {}).getChildContext();

  /**
   * Displays chart options to the user
   * type: timeRange displays an input and sets the start/end for the api request
   * type: queueFilter displays an input and sets the queue/s for the api request
   */
  const chartOptions = [
    new ChartOption({ type: 'queueFilter', required: false }),
  ];

  const agent = new Agent(intl);

  return new Chart({
    type: 'ResponsiveGridTable',
    chartOptions,
    dataOptions: {
      Agent: agent.dataOptions,
    },
    queryParams: {},
  });
};
